import { useState } from "react";
import { useRouteContext } from "../../../../context/RouteContext";
import useEvaApi, { EvaApiCall } from "../../../../hooks/useEvaApi";
import AccessCommander2NConfigPageView from "./AccessCommander2NConfigPageView";
import { useParams } from "react-router-dom";
import useCustomEffect from "../../../../hooks/useCustomEffect";
import { useAuthContext } from "../../../../context/AuthContext";

function AccessCommander2NConfigPage() {
  const routeContext = useRouteContext();
  const callEvaApi = useEvaApi();
  const { access_commander } = useParams();
  const [submitError, setSubmitError] = useState(null);
  const authContext = useAuthContext();
  const [accessCommanderData, setAccessCommanderData] = useState({
    company_id: authContext.auth.user?.company?.id,
    api_token: "",
    url: "",
    username: "",
    password: "",
    company_name: "",
    group_name: "",
    type: "commander",
  });

  /**
   * initialize the page
   */
  useCustomEffect(() => {
    if (access_commander) {
      fetchAccessCommanderData();
    }
  });

  /**
   * This method will fetch the access commander data from the API
   */
  async function fetchAccessCommanderData() {
    await callEvaApi(
      new EvaApiCall(`integrations/access_commander/units/${access_commander}`)
        .setLoadingGroup("access_commander_2n_config_page_fetch")
        .setOnSuccess((response) => {
          const data = response.data.data;
          setAccessCommanderData({
            company_id: authContext.auth.user?.company?.id,
            api_token: data.api_token || "",
            url: data.url || "",
            username: data.username || "",
            password: data.password || "",
            company_name: data.company_name || "",
            group_name: data.group_name || "",
            type: data.type || "commander",
          });
        })
        .setRedirectOnError(true)
    );
  }

  /**
   * This method will update the api token on input change
   * @param {*} value 
   */
  function onApiTokenChange(e) {
    setAccessCommanderData((prev) => ({ ...prev, api_token: e.target.value }));
  }

  /**
   * This method will update the URL on input change
   * @param {*} value 
   */
  function onUrlChange(e) {
    setAccessCommanderData((prev) => ({ ...prev, url: e.target.value }));
  }

  /**
   * This method will update the username on input change
   * @param {*} value 
   */
  function onUsernameChange(e) {
    setAccessCommanderData((prev) => ({ ...prev, username: e.target.value }));
  }

  /**
   * This method will update the password on input change
   * @param {*} value 
   */
  function onPasswordChange(e) {
    setAccessCommanderData((prev) => ({ ...prev, password: e.target.value }));
  }

  /**
   * This method will update the company name on input change
   * @param {*} value 
   */
  function onCompanyNameChange(e) {
    setAccessCommanderData((prev) => ({ ...prev, company_name: e.target.value }));
  }

  /**
   * This method will update the group name on input change
   * @param {*} value 
   */
  function onGroupNameChange(e) {
    setAccessCommanderData((prev) => ({ ...prev, group_name: e.target.value }));
  }

  /**
   * This method will update the type on input change
   * @param {*} e 
   */
  function onTypeChange(value) {
    setAccessCommanderData({ ...accessCommanderData, type: value });
  }

  /**
   * This method will handle the onCancel functionality
   */
  function onCancel() {
    routeContext.back();
  }

  /**
   * This method will submit the form to the EVA API and handles its response
   */
  async function onSubmit() {
    await callEvaApi(
      new EvaApiCall(access_commander 
        ? `integrations/access_commander/units/${access_commander}`
        : "integrations/access_commander/units")
        .setLoadingGroup("access_commander_2n_config_page_save")
        .setMethod(access_commander ? "PUT" : "POST")
        .setData(accessCommanderData)
        .setErrorState(setSubmitError)
        .setRedirectOnSuccess(true)
    );
  }

  return (
    <AccessCommander2NConfigPageView 
      onSubmit={onSubmit}
      onCancel={onCancel}
      onApiTokenChange={onApiTokenChange}
      onUrlChange={onUrlChange}
      onUsernameChange={onUsernameChange}
      onPasswordChange={onPasswordChange}
      onCompanyNameChange={onCompanyNameChange}
      onGroupNameChange={onGroupNameChange}
      onTypeChange={onTypeChange}
      submitError={submitError}
      accessCommanderData={accessCommanderData}
    />
  );
}

export default AccessCommander2NConfigPage;